// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__oQp3x","title":"Images90_title__2ZOcd","images":"Images90_images__2wNlm"};